export default __webpack_public_path__ + "static/media/heroImage12.30d86ddd.webp";